/* eslint-disable @typescript-eslint/no-explicit-any */
import {CardProduct} from "@/components/CardProduct/interface";

import {Palier} from "./detailOffre";

export interface Massifications {
  offre_id: number | string;
  nom: string;
  date_debut: string;
  date_fin: string;
  articles: CardProduct[];
  type_palier: "prix" | "quantite";
  paliers: Palier[];
  engagement_total_montant: string;
  engagement_total_unites: number;
  engagement_total_adherents: number;
}

export interface OffresReponse {
  massifications: Massifications[];
}

export type OffreType = "massification" | "operationCommerciale";

type OffreConfig = {
  color: "primary" | "secondary" | "tertiarie";
  message: string;
};

export const offerConfigMap: Record<OffreType, OffreConfig> = {
  massification: {color: "primary", message: "Détail et Engagement"},
  operationCommerciale: {color: "primary", message: "Opération commerciale"},
};

export const defaultConfig: OffreConfig = {color: "primary", message: ""}; // default values
